import * as React from 'react';
import { Label } from '@/components/ui/label';

/**
 * PADRÃO DE CAMPO DO APP (o desenho de `/quotes/new`).
 *
 * Dois campos lado a lado só ficam alinhados se o RÓTULO tiver altura fixa: um
 * rótulo com ícone é mais alto que um só de texto, e a diferença empurra o input
 * de baixo. `FieldLabel` trava a altura em `h-4` e `FIELD_INPUT` trava a altura
 * do controle em `h-10`; toda grade de campos usa os dois + `items-start`.
 *
 * Vivia privado dentro do `QuoteForm`. Saiu de lá quando a segunda tela adotou o
 * mesmo desenho (o formulário de cliente): duas cópias da mesma medida é como o
 * app acabou com dois vocabulários de unidade incompatíveis (CLAUDE.md #64).
 */
export function FieldLabel({
  icon: Icon,
  htmlFor,
  children,
}: {
  icon?: React.ElementType;
  /**
   * Associa o rótulo ao controle. OPCIONAL porque a maioria dos campos do
   * orçamento não tem `id` (o rótulo é puramente visual ali), mas quando o
   * campo tem `id` isto é o que faz o leitor de tela anunciar o nome — e é o
   * que permite achar o campo pelo rótulo em teste, em vez de por seletor CSS.
   */
  htmlFor?: string;
  children: React.ReactNode;
}) {
  return (
    <Label htmlFor={htmlFor} className="flex h-4 items-center gap-1.5 text-xs font-medium">
      {Icon && <Icon className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />}
      {children}
    </Label>
  );
}

/** Altura/forma únicas de todo controle de formulário. */
export const FIELD_INPUT = 'h-10 rounded-xl bg-background';

/**
 * Cartão de conteúdo do desenho oficial. Literal completo de propósito: o
 * Tailwind JIT só enxerga a classe se ela aparecer inteira no código-fonte (o
 * mesmo motivo documentado em `src/lib/cardStyles.ts`).
 */
export const CONTENT_CARD = 'rounded-2xl border border-border/60 bg-card shadow-sm';
